import { styled } from '@mui/material';

import { CIButton } from 'common/viewcomp/forms/buttons';

export const TextButton = styled(CIButton)(({ theme }) => ({
    color: theme.ciPalette.common.blue,
    border: 0,

    '& .loading-overlay__content': {
        textTransform: 'none',
    },

    '& path': {
        fill: theme.ciPalette.common.blue,
    },

    '&.Mui-disabled svg path': {
        fill: theme.palette.text.disabled,
    },
}));
